module.exports = __webpack_public_path__ + "static/media/wolf1.c8c03594.png";